<template>
  <transition name="fade">
    <div class="userModal" v-if="show" v-on:click="showUserSelector = false">
      <div class="overlay"></div>
      <div :class="{modalContent: true, modalBig: true}">
        <div class="loading" v-if="loading"></div>
        <div class="close" v-on:click="close(false)"></div>
        <h4>Donation Budget</h4>
        <form v-on:submit.prevent="handleSubmit">
          <div class="fieldGroup">
            <div class="fieldCnt" :class="{hasError: form.name.error}">
              <label>Budget Name</label>
              <input type="text" class="field" placeholder="Budget name..."
                v-model="form.name.model" v-on:input="fieldChanged('name')">
              <div class="fieldError" v-if="form.name.error">
                {{form.name.error}}
              </div>
            </div>
          </div>
          <div class="fieldGroup">
            <div :class="{fieldCnt: true}">
              <label>Description</label>
              <textarea class="field" placeholder="Budget description..."
                v-model="form.description.model"></textarea>
            </div>
          </div>
          <div class="fieldGroup">
            <div class="fieldCnt" :class="{hasError: form.amount.error}">
              <label>Amount</label>
              <input type="number" class="field hasPrefix"
                placeholder="Budget amount..." v-model="form.amount.model"
                v-on:input="fieldChanged('amount')">
              <div class="fieldPrefix">Rp</div>
              <div class="fieldError" v-if="form.amount.error">
                {{form.amount.error}}
              </div>
            </div>
          </div>
          <div class="btnCnt">
            <button class="btn btnSecondary" type="button"
              v-on:click="close(false)" v-if="!saving">
              Cancel
            </button>
            <button class="btn btnPrimary" :class="{btnLoading: saving}">
              <span>Save Changes</span>
            </button>
          </div>
        </form>
      </div>
      <MediaSelector ref="mediaSelector"/>
    </div>
  </transition>
</template>

<script>
import MediaSelector from '@/components/MediaSelector.vue';

export default {
  components: { MediaSelector },
  data() {
    return {
      id: null,
      donationId: null,
      loading: false,
      show: false,
      saving: false,
      form: {
        name: { model: '', error: null },
        description: { model: '', error: null },
        amount: { model: '', error: null },
      },
    };
  },
  methods: {
    open(donationId, d, n) {
      this.donationId = donationId;
      this.id = (d && d.id) ? d.id : null;
      this.form.name.model = (d && d.name) ? d.name : '';
      this.form.name.error = null;
      this.form.description.model = (d && d.description) ? d.description : '';
      this.form.amount.model = (d && d.amount) ? d.amount : '';
      this.form.amount.error = null;
      this.next = n;
      this.show = true;
      this.saving = false;
    },
    close(b, d) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, d);
    },
    doNothing() {},
    fieldChanged(field) {
      this.form[field].error = null;
    },
    addImage() {
      this.$refs.mediaSelector.open(null, (b, media) => {
        if (b) this.media = media;
      });
    },
    handleSubmit() {
      if (this.saving) return;
      const formData = {
        donationId: this.donationId,
        name: this.form.name.model,
        description: this.form.description.model,
        amount: this.form.amount.model,
      };
      if (!formData.name || formData.name === '') {
        this.form.name.error = 'Please input budget name';
        return;
      }
      if (!formData.amount || formData.amount === '') {
        this.form.amount.error = 'Please input budget amount';
        return;
      }
      if (this.id) formData.id = this.id;
      this.saving = true;
      this.$http.post(this.$config.uri(`donation/${this.donationId}/budget`), formData).then((r) => {
        this.saving = false;
        if (r.data.status !== 200) {
          // Display error
          return;
        }
        this.close(true, r.data.data);
      });
    },
  },
  mounted() {
  },
};
</script>

<style scoped lang="scss">
  .userModal{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 991;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: auto;
    padding: 40px 0;

    .addCategory{
      color: #0245a7;
      display: inline-block;
      float: right;
      border-radius: 50px;
      margin-top: 4px;
      padding: 4px 10px 6px;
      cursor: pointer;
      &:hover{
        background-color: #eee;
      }
      img{
        height: 18px;
        float: left;
        margin-right: 7px;
        margin-top: 1px;
      }
    }

    .fieldCnt{
      position: relative;
      .fieldLoading{
        position: absolute;
        right: 10px; top: 33px;
        z-index: 3;
        img{
          height: 24px;
        }
      }
      .theMan{
        position: relative;
        border-radius: 5px;
        border: #ccc 1px solid;
        display: flex;
        align-items: center;
        border-color: #0e5dd2;
        background-color: #e9f2ff;
        padding-left: 54px;
        padding-right: 38px;
        box-sizing: border-box;
        height: 48px;
        h5{
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          font-size: 17px;
          color: #0747a6;
          font-weight: 600;
          margin: 0;
        }
        .profilePict{
          width: 36px; height: 36px;
          position: absolute;
          left: 10px; top: 50%;
          margin-top: -18px;
          background-color: #0e5dd2;
          border-radius: 50%;
          color: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          &.email{
            background-color: #e9f2ff;
            background-image: url(../assets/envelope.png);
            background-size: 18px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
        }
        .close{
          position: absolute;
          right: 6px; top: 50%;
          border-radius: 50%;
          margin-top: -15px;
          width: 30px; height: 30px;
          background-image: url(../assets/close.png);
          background-size: 12px auto;
          background-repeat: no-repeat;
          background-position: center;
          cursor: pointer;
          opacity: .5;
          // transition: all .2s ease;
          &:hover{
            opacity: .8;
            background-color: #fff;
          }
        }
        &.hasError{
          background-color: #fff4f4;
          border-color: red;
          h5{
            color: red;
          }
          .profilePict{
            background-color: red;
            &.email{
              background-color: #fff4f4;
            }
          }
        }
      }
    }
    .fieldCnt.hasError{
      .field{
        border-color: red;
      }
      .fieldHint{
        display: none;
      }
      .fieldError{
        display: block;
      }
    }
    .fieldCnt.hasPrefix{
      position: relative;
      .field{
        padding-left: 40px;
      }
      .fieldPrefix{
        position: absolute;
        left: 10px; top: 35px;
        z-index: 3;
        color: #767676;
      }
    }

    .overlay{
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
    }
    .modalContent{
      position: relative;
      z-index: 2;
      background: #fff;
      width: 260px;
      margin: auto;
      border-radius: 5px;
      padding: 40px 100px;
      overflow: hidden;
      transition: all .3s ease;

      .pricingItem{
        margin-bottom: 26px;
        .loadingPackage{
          height: 100px;
          background-image: url(../assets/loading-2.svg);
          background-size: 40px auto;
          background-position: -4px 16px;
          background-repeat: no-repeat;
        }
        .pricingItemIn{
          cursor: pointer;
          border-radius: 10px;
          padding: 8px 10px 10px 40px;
          margin: 0 -10px 4px;
          // margin: 0 0 4px;
          position: relative;
          &:hover{
            background-color: #f5f5fe;
            .checkCnt{
              .checkIn{
                border-color: #666;
              }
            }
          }
        }
        .checkCnt{
          position: absolute;
          width: 30px; height: 30px;
          left: 4px; top: 8px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          .checkIn{
            width: 16px; height: 16px;
            box-sizing: border-box;
            border: #999 2px solid;
            border-radius: 3px;
            background-size: 18px auto;
            background-position: -2px -5px;
            background-repeat: no-repeat;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          &:hover{
            background-color: #e5e5e5;
            .checkIn{
              border-color: #444;
            }
          }
          &.radio{
            .checkIn{
              border-radius: 50%;
            }
          }
          &.checked{
            .checkIn{
              background-color: #0067ff;
              border-color: #0067ff !important;
              background-image: url(../assets/tick-white.png);
            }
            &.radio{
              .checkIn{
                background-color: #0067ff;
                border-color: #0067ff !important;
                background-image: none;
                &:before{
                  content: "";
                  position: absolute;
                  width: 8px; height: 8px;
                  border-radius: 50%;
                  border: #fff 2px solid;
                }
              }
            }
          }
        }
        h4{
          font-size: 20px;
          font-weight: 600;
          margin: 0 0 2px;
        }
        p{
          margin: 0;
        }
        .packageCnt{
          padding: 0 30px;
          color: #444;
          &.priceField{
            margin-bottom: 20px;
            label{
              margin-bottom: 6px;
            }
            .fieldCnt{
              // max-width: 300px;
            }
          }
          label{
            font-size: 14px;
            margin: 0 0 2px;
            display: block;
            text-transform: uppercase;
            color: #999;
            font-weight: bold;
          }
          .packageItem{
            padding: 8px 10px 10px 40px;
            margin: 0 -10px;
            border-radius: 5px;
            position: relative;
            cursor: pointer;
            &:hover{
              background-color: #f5f5fe;
            }
            h4{
              color: inherit;
              font-size: 18px;
            }
            .price{
              font-size: 18px;
              font-weight: bold;
              margin: 0 0 2px;
              span{
                font-weight: normal;
              }
            }
            p{
              color: inherit;
              opacity: .7;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
          }
        }
        &.notChecked{
          .packageCnt{
            opacity: .6;
            .fieldError{
              display: none;
            }
            .field{
              background-color: #e5e5e5;
              border-color: #d5d5d5;
            }
            .packageItem{
              cursor: default;
              background-color: #fff;
              .checkCnt{
                background-color: #fff;
                &.checked{
                  .checkIn{
                    background-color: #999;
                    border-color: #999 !important;
                  }
                }
              }
              h4, .price{
                color: #767676;
              }
            }
          }
        }
      }


      .loading{
        position: absolute;
        top: 0; left: 0; right: 0; bottom: 0;
        background-color: #fff;
        background-color: rgba(255,255,255,.7);
        backdrop-filter: saturate(180%) blur(20px);
        background-image: url(../assets/loading-2.svg);
        background-position: center;
        background-size: 70px auto;
        background-repeat: no-repeat;
        z-index: 9;
      }
      .close{
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background-image: url(../assets/close.png);
        background-size: 14px auto;
        background-position: center;
        background-repeat: no-repeat;
        position: absolute;
        right: 10px;
        top: 10px;
        opacity: .4;
        cursor: pointer;
        transition: all .2s linear;
      }
      .close:hover{
        background-color: #e5e5e5;
        opacity: .7;
      }
      h4{
        font-size: 30px;
        margin: 0;
        margin-bottom: 20px;
      }
      .btnCnt{
        text-align: right;
        border-top: #eee 1px solid;
        margin: 0 -80px -40px;
        padding: 12px 30px 2px;
        &.saveDisabled{
          .btnPrimary{
            background-color: #ccc;
            color: #999;
            box-shadow: none;
            cursor: default;
          }
        }
      }
      .btn{
        margin-left: 5px;
        margin-bottom: 10px;
        &.saving{
          background-color: #ccc;
          color: #999;
          cursor: default;
          box-shadow: none;
        }
      }
    }
  }

  .modalContent.modalBig{
    width: 480px;
    padding: 40px 80px;
    .fieldGroupBos{
      display: flex;
      margin-bottom: 10px;
      .fieldCnt{
        box-sizing: border-box;
        width: calc(100% - 200px);
        &.priceCnt{
          width: 180px;
          margin-right: auto;
        }
      }
      .recomended{
        padding: 34px 0 0 30px;
        margin-left: auto;
        display: flex;
        label{
          display: block;
          margin: 0;
          margin-right: 14px;
          padding-top: 3px;
        }
        .toggle{
          background-color: #e5e5e5;
          border-radius: 50px;
          width: 40px;
          height: 26px;
          position: relative;
          cursor: pointer;
          &:hover{
            background-color: #ddd;
          }
          &:before{
            content: "";
            display: block;
            position: absolute;
            left: 3px; top: 3px;
            background-color: #fff;
            width: 20px; height: 20px;
            border-radius: 50%;
            transition: all .2s ease;
          }
          &.on{
            background-color: #0067ff;
            &:before{
              left: 16px;
            }
          }
        }
      }
    }
    .fieldGroup2{
      .fieldCnt{
        float: left;
        width: calc(50% - 10px);
      }
      .fieldCnt.fieldCnt1{
        margin-right: 20px;
      }
    }
    .logoCnt{
      padding-left: 90px;
      height: 70px;
      position: relative;
      padding-top: 18px;
      box-sizing: border-box;
      .logo{
        border: #eee 1px solid;
        width: 70px;
        height: 70px;
        border-radius: 5px;
        position: absolute;
        left: 0; top: 0;
        cursor: pointer;
        background-color: #eee;
        font-weight: bold;
        font-size: 20px;
        color: #bbb;
        text-align: center;
        padding-top: 20px;
        box-sizing: border-box;
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
        &.logoProfile{
          border-radius: 50%;
          background-size: cover;
        }
        &.hasLogo{
          background-color: #fff;
          span{
            display: none;
          }
        }
        &:hover{
          border-color: #ddd;
        }
      }
      .addLogo{
        border: #0057d8 1px solid;
        border-radius: 4px;
        background-color: #fff;
        color: #0057d8;
        padding: 8px 12px;
        cursor: pointer;
        &:hover{
          box-shadow: 2px 2px 4px rgba(0,0,0,.2);
        }
      }
    }
  }
</style>
